// Display helpers for turning a user's email into a friendly name, initials
// and a stable avatar colour. Shared by the sidebar admin tools and the
// settings page.

// "jorien.bussink@embracecloud.nl" → "Jorien Bussink"
export const displayName = (email: string): string => {
  const local = (email || '').split('@')[0]
  if (!local) return email || 'Unknown'
  return (
    local
      .split(/[._-]+/)
      .filter(Boolean)
      .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
      .join(' ') || email
  )
}

export const initials = (email: string): string => {
  const parts = displayName(email).split(' ').filter(Boolean)
  const two = (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')
  return (two || email?.[0] || '?').toUpperCase()
}

// Stable pleasant colour per user from their email.
export const avatarHue = (email: string): number => {
  let h = 0
  for (let i = 0; i < (email || '').length; i++) h = (h * 31 + email.charCodeAt(i)) % 360
  return h
}
